var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-format-list-checkbox",
      show: _vm.dialog,
      maxWidth: "50%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            autofocus: "",
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            error: !!_vm.errors.code,
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }